// extracted by mini-css-extract-plugin
export var collapsibleList__button = "CollapsibleList--collapsibleList__button--KsyXB";
export var collapsibleList__closed = "CollapsibleList--collapsibleList__closed--29VZQ";
export var collapsibleList__icon = "CollapsibleList--collapsibleList__icon--sRC2N";
export var collapsibleList__open = "CollapsibleList--collapsibleList__open--wbtDA";
export var collapsibleList__text = "CollapsibleList--collapsibleList__text--r0h5r";
export var collapsibleList__title = "CollapsibleList--collapsibleList__title--n5OPs";
export var tkMyriadProSemiCondensed = "CollapsibleList--tk-myriad-pro-semi-condensed--WjxL3";